import React from 'react';
import MainBanner from '../HomeFour/MainBanner';
import About from '../AboutThree/About';
import Training from '../Common/WhyUs';
import Speakers from '../AboutThree/Speakers';
import GoTop from '../Shared/GoTop';
import Footer from '../Common/Footer';
import SpeakersTwo from '../HomeTwo/Speakers';
import EventSchedules from '../HomeDefault/EventSchedules';
import FunFact from '../Common/FunFact';
import Pricing from '../HomeDefault/Pricing';
import lax from 'lax.js';
// import Cta from '../Common/Cta';
import Kit from '../Common/Kit';
// import Partner from '../Common/Partner';
import LatestNews from '../HomeDefault/LatestNews';
import BuyTicket from '../Common/BuyTicket';
import Subscribe from '../Common/Subscribe';
import Contact from './Contact';
import SpeakersOne from './SpeakersOne';
import WhyUs from '../HomeFour/WhyUs';
import PlatinumSponsors from '../LaxButton/PlatinumSponsors';
import GoldSponsors from '../LaxButton/GoldSponsors';
import Partner from '../Common/Partner';
import AboutFour from '../HomeFour/About';
import About1 from '../HomeFour/About1';
 
class HomeDefault extends React.Component {
    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }
    render(){
        return (
            <React.Fragment>
                 <div className="position-fixed  bottom-0  end-0 p-2 rounded-10   text-green" style={{marginRight: "2%",   zIndex: 1000,   width: "40px" ,  textAlign:"center", fontSize: "40px" }}>
                 <a  href="whatsapp://send?phone=+918108818113"><i class="icofont-whatsapp" style={{color: " #25D366"}} ></i></a>
          </div>
                {/* Main Banner */}
                <MainBanner />
                <About />
                <About1 />
                <AboutFour />
                {/* About Area */}
                {/* <About /> */}
                {/* Why Choose Us Area */}
                {/* <SpeakersTwo /> */}
                {/* <Cta /> */}
                {/* <Kit/> */}
                

                {/* Speakers Area */}
                {/* <Speakers /> */}
                <Training />
                <Partner />
                {/* <PlatinumSponsors />
                <GoldSponsors />  */}
            

                {/* Schedule Area */}
                {/* <EventSchedules /> */}
                {/* FunFacts Area */}
               
                {/* Pricing Area */}
                {/* <Pricing /> */}
                {/* Partner Area */}
                {/* <Partner /> */}
                {/* <Contact/> */}
                {/* Blog Area */}
                {/* <LatestNews /> */}
                {/* Buy Tickets Area */}
                {/* <BuyTicket /> */}
                {/* Subscribe Area */}
                {/* <Subscribe /> */}
                <WhyUs />
                <FunFact />


                <SpeakersOne />

                <Footer />

                {/* Back Top top */}
                <GoTop scrollStepInPx="50" delayInMs="16.66" />
            </React.Fragment>
        );
    }
}
 
export default HomeDefault;